// System Logs Mutations

export const updateLogsList = (state, payload) => {
  state.logsList = payload
}

export const setLogInfo = (state, payload) => {
  state.logInfo = payload
}
